<ip-image-preview
  (detail)="onDetail($event)"
  [activeItem]="activeRecord"
  [id]="getActiveRecordId()"
  [items]="imageItems"
  [castorUrl]="castorUrl$ | async"
  [pagination]="pagination"
  [coreId]="coreId$ | async"
></ip-image-preview>
